import { combineReducers } from 'redux';
import user from './User';
import stories from './Stories';
import search from './Search';
import showRefreshButton from './showRefreshButton';
import entities from './Entities';
import loading from './Loading';
import org from './Org';
import board from './Board';
import boardAnalytics from './BoardAnalytics';
import { SIGN_OUT } from '../constants';
import { optimistic } from 'redux-optimistic-ui';
import influencer from './Influencer';
import admin from './Admin';
import competition from './Competition';
import newInbox from './NewInbox';

const appReducer = combineReducers({
  user,
  entities,
  stories: optimistic(stories),
  search,
  showRefreshButton,
  loading,
  org: optimistic(org),
  board: optimistic(board),
  boardAnalytics,
  influencer: optimistic(influencer),
  admin,
  competition: optimistic(competition),
  newInbox: optimistic(newInbox),
});

function rootReducer(state: any, action: any) {
  if (action.type === SIGN_OUT) {
    const newState = appReducer({} as any, action);
    return newState;
  }

  return appReducer(state, action);
}

export default rootReducer;
